import { lazy, Suspense } from 'react';

// Lazy load the VideoModal component (includes @videosdk.live/rtc-js-prebuilt)
const VideoModal = lazy(() => import('./VideoModal'));

// Loading skeleton for video modal
function VideoModalSkeleton() {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-4xl h-[600px] flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                    <p className="text-gray-600">Loading video conference...</p>
                </div>
            </div>
        </div>
    );
}

export default function LazyVideoModal() {
    return (
        <Suspense fallback={<VideoModalSkeleton />}>
            <VideoModal />
        </Suspense>
    );
}
